import { Suspense, lazy } from 'react';
import LogoutPage from '../pages/member/LogoutPage';
const Loading = <div>Loading....</div>;
const Login = lazy(() => import('../pages/member/LoginPage'));
const Register = lazy(() => import('../pages/member/RegisterPage'));
const RegisterForm = lazy(() => import('../pages/member/RegisterFormPage'));
const IdCheck = lazy(() => import('../pages/member/IdCheck'));

const memberRouter = () => {
  return [
    {
      path: 'login',
      element: (
        <Suspense fallback={Loading}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: 'idcheck',
      element: (
        <Suspense fallback={Loading}>
          <IdCheck />
        </Suspense>
      ),
    },
    {
      path: 'pwcheck',
      element: (
        <Suspense fallback={Loading}>
          <IdCheck />
        </Suspense>
      ),
    },
    {
      path: 'register',
      element: (
        <Suspense fallback={Loading}>
          <Register />
        </Suspense>
      ),
    },
    {
      path: 'register-form/:memberType',
      element: (
        <Suspense fallback={Loading}>
          <RegisterForm />
        </Suspense>
      ),
    },
    {
      path: 'logout',
      element: (
        <Suspense fallback={Loading}>
          <LogoutPage />
        </Suspense>
      ),
    },
    {
      path: 'logout/:logoutType',
      element: (
        <Suspense fallback={Loading}>
          <LogoutPage />
        </Suspense>
      ),
    },
  ];
};

export default memberRouter;
